module.exports = __webpack_public_path__ + "img/company.4b48343.svg";